import { notification, Row } from "antd";

import SingleProcurementPageV3 from "../SingleProcurementPageV3";

const DataSection = ({isUserAllowed}) => { 
  return (
    <Row>
       <SingleProcurementPageV3 isUserAllowed={isUserAllowed}/>
    </Row>
  )
};

export default DataSection;
